// rel="noopener" kept as in the design (noreferrer would hide the referrer from stores/WhatsApp)
/* eslint-disable react/jsx-no-target-blank */
const Pedagogy = () => (
  <section id="pedagogy" style={{ maxWidth: "1280px", margin: "0 auto", padding: "0 24px 0", display: "flex", flexDirection: "column", gap: "48px" }}>
    <section id="features" style={{ background: "#FFFFFF", borderTop: "1px solid #E1E5F7", borderBottom: "1px solid #E1E5F7" }}>
      <div style={{ maxWidth: "1280px", margin: "0 auto", padding: "56px 24px 104px", display: "flex", flexDirection: "column", gap: "40px" }}>
        <div style={{ display: "flex", flexDirection: "column", gap: "12px", alignItems: "center", textAlign: "center" }}>
          <span style={{ fontWeight: "700", color: "#1E8F80", fontSize: "16px" }}>
            مميزات التطبيق
          </span>
          <h2 style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "clamp(34px, 4vw, 52px)", lineHeight: "1.2" }}>
            لماذا يختار الأولياء والمربّون خطوة ؟
          </h2>
        </div>
        <div role="tablist" aria-label="مميزات التطبيق" style={{ display: "flex", gap: "10px", flexWrap: "wrap", justifyContent: "center" }}>
          <button type="button" role="tab" id="kh-tab-0" aria-controls="kh-panel-0" aria-selected="true" data-tab="0" style={{ minHeight: "48px", padding: "0 20px", borderRadius: "999px", cursor: "pointer", fontWeight: "700", fontSize: "15px", border: "2px solid #141C63", background: "#141C63", color: "#FFFFFF" }}>
            محتوى متوافق مع المناهج الدراسيّة
          </button>
          <button type="button" role="tab" id="kh-tab-1" aria-controls="kh-panel-1" aria-selected="false" data-tab="1" style={{ minHeight: "48px", padding: "0 20px", borderRadius: "999px", cursor: "pointer", fontWeight: "700", fontSize: "15px", border: "2px solid #E1E5F7", background: "#FFFFFF", color: "#121A4A" }}>
            تذليل صعوبات التعلّم
          </button>
          <button type="button" role="tab" id="kh-tab-2" aria-controls="kh-panel-2" aria-selected="false" data-tab="2" style={{ minHeight: "48px", padding: "0 20px", borderRadius: "999px", cursor: "pointer", fontWeight: "700", fontSize: "15px", border: "2px solid #E1E5F7", background: "#FFFFFF", color: "#121A4A" }}>
            الواقع المعزز
          </button>
          <button type="button" role="tab" id="kh-tab-3" aria-controls="kh-panel-3" aria-selected="false" data-tab="3" style={{ minHeight: "48px", padding: "0 20px", borderRadius: "999px", cursor: "pointer", fontWeight: "700", fontSize: "15px", border: "2px solid #E1E5F7", background: "#FFFFFF", color: "#121A4A" }}>
            هرم بلوم للأهداف التعليمية
          </button>
          <button type="button" role="tab" id="kh-tab-4" aria-controls="kh-panel-4" aria-selected="false" data-tab="4" style={{ minHeight: "48px", padding: "0 20px", borderRadius: "999px", cursor: "pointer", fontWeight: "700", fontSize: "15px", border: "2px solid #E1E5F7", background: "#FFFFFF", color: "#121A4A" }}>
            ما يقدّمه تطبيق خطوة للأولياء
          </button>
        </div>
        <div className="kh-panel" id="kh-panel-0" role="tabpanel" aria-labelledby="kh-tab-0" data-panel="0">
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(460px, 100%), 1fr))", gap: "40px", alignItems: "center", background: "#F3F5FF", borderRadius: "32px", padding: "clamp(24px, 4vw, 56px)" }}>
            <div style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
              <span style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "64px", lineHeight: "1", color: "#1E8F80" }}>
                01
              </span>
              <h3 style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontSize: "34px", lineHeight: "1.3" }}>
                يلعب طفلك… ويتعلّم ما يدرسه في القسم تمامًا.
              </h3>
              <p style={{ margin: "0", fontSize: "18px", lineHeight: "1.9", color: "#3A4270" }}>
                جميع الموادّ الدراسيّة المُقدّمة تتطابق مع البرنامج الرسميّ للمرحلة الابتدائيّة، درسًا بدرس. وحين نتجاوزه، فذلك لنُثريه ونُعمّق فهم طفلك ونُوسّع معارفه.
              </p>
              <p style={{ margin: "0", fontSize: "18px", lineHeight: "1.9", color: "#3A4270" }}>
                خلف كلّ محتوى، فريق بيداغوجيّ مختصّ يُصمّم ويُراجع ويُدقّق، حتّى يصل إلى طفلك تعلّمٌ موثوق بأعلى جودة.
              </p>
              <strong style={{ alignSelf: "flex-start", padding: "10px 18px", borderRadius: "16px", background: "#FFC93C", color: "#0B1240", fontSize: "19px" }}>
                وقت الشاشة… صار وقتًا للنجاح المدرسيّ.
              </strong>
            </div>
            <div style={{ boxSizing: "border-box", transform: "rotate(-10deg)" }}>
              <div style={{ background: "#FFC93C", borderRadius: "36px", padding: "40px", display: "flex", flexDirection: "column", gap: "18px", position: "relative", overflow: "hidden", minHeight: "420px", justifyContent: "flex-end", height: "324px" }}>
                <img width="432" height="578" loading="lazy" decoding="async" src="/assets/img/boy-cheer.webp" alt="" style={{ position: "absolute", top: "-21px", left: "-32px", width: "300px", height: "auto", transform: "rotate(8deg)" }} />
                <h2 style={{ position: "relative", margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "clamp(32px, 3.6vw, 46px)", lineHeight: "1.2", color: "#0B1240", maxWidth: "420px", width: "303px", transform: "rotate(9deg)" }}>
                  وقت شاشة مفيد… وأنت مطمئنّ
                </h2>
                <span style={{ position: "relative", fontWeight: "800", fontSize: "15px", color: "#6E4A00", transform: "rotate(9deg)" }}>
                  فضاء الولي
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="kh-panel" id="kh-panel-1" role="tabpanel" aria-labelledby="kh-tab-1" data-panel="1" hidden>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(460px, 100%), 1fr))", gap: "40px", alignItems: "center", background: "#F3F5FF", borderRadius: "32px", padding: "clamp(24px, 4vw, 56px)" }}>
            <div style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
              <span style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "64px", lineHeight: "1", color: "#1E8F80" }}>
                02
              </span>
              <h3 style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontSize: "34px", lineHeight: "1.3" }}>
                تطبيق «خُطوة»: رفيق طفلك نحو تعلّمٍ أيسر وأمتع
              </h3>
              <p style={{ margin: "0", fontSize: "18px", lineHeight: "1.9", color: "#3A4270" }}>
                يتميّز تطبيق «خُطوة» بقدرته على مساعدة الأطفال الذين يواجهون صعوبات في التعلّم، عبر أنشطة مُكيَّفة خصّيصًا لاحتياجاتهم، تُمكّن الأولياء والمربّين من تقديم الدعم المناسب لكلّ طفل.
              </p>
              <p style={{ margin: "0", fontSize: "18px", lineHeight: "1.9", color: "#3A4270" }}>
                نعمل باستمرار على تطوير «خُطوة» ليكون رفيقًا موثوقًا يصحب الأطفال في رحلة تعليميّة فريدة وممتعة، يكتشفون فيها قدراتهم ويُطلقون كامل إمكاناتهم، ويتجاوزون صعوباتهم خطوةً بخطوة نحو أفضل النتائج.
              </p>
            </div>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <svg viewBox="0 0 400 420" width="360" style={{ maxWidth: "100%", height: "auto" }} role="img" aria-label="أيقونة تذليل صعوبات التعلّم: درجات ملوّنة يصعدها الطفل خطوة بخطوة نحو النجمة">
                <defs>
                  <linearGradient id="khDifBg" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0" stopColor="#4FE0CA" />
                    <stop offset="1" stopColor="#169A8A" />
                  </linearGradient>
                  {" "}
                  <pattern id="khDifDots" width="22" height="22" patternUnits="userSpaceOnUse">
                    <circle cx="4" cy="4" r="2" fill="#FFFFFF" fillOpacity="0.22" />
                  </pattern>
                </defs>
                {" "}
                <rect x="0" y="18" width="400" height="400" rx="84" fill="#0E6E63" />
                {" "}
                <rect x="0" y="0" width="400" height="400" rx="84" fill="url(#khDifBg)" />
                {" "}
                <rect x="0" y="0" width="400" height="400" rx="84" fill="url(#khDifDots)" />
                {" "}
                <path d="M60 40 h280 a60 60 0 0 1 40 18 c-90 -10 -250 -10 -360 0 a60 60 0 0 1 40 -18z" fill="#FFFFFF" fillOpacity="0.25" />
                {" "}
                <rect x="272" y="270" width="76" height="70" rx="14" fill="#C48E00" />
                <rect x="272" y="262" width="76" height="70" rx="14" fill="#FFC93C" />
                {" "}
                <rect x="190" y="210" width="76" height="130" rx="14" fill="#C96A12" />
                <rect x="190" y="202" width="76" height="130" rx="14" fill="#FF9A3D" />
                {" "}
                <rect x="108" y="150" width="76" height="190" rx="14" fill="#B2357F" />
                <rect x="108" y="142" width="76" height="190" rx="14" fill="#F27DC2" />
                {" "}
                <rect x="26" y="90" width="76" height="250" rx="14" fill="#5A3FC0" />
                <rect x="26" y="82" width="76" height="250" rx="14" fill="#A58BFF" />
                {" "}
                <text x="310" y="306" textAnchor="middle" fontFamily="'Baloo Bhaijaan 2', sans-serif" fontWeight="800" fontSize="30" fill="#0B1240">
                  1
                </text>
                {" "}
                <text x="228" y="246" textAnchor="middle" fontFamily="'Baloo Bhaijaan 2', sans-serif" fontWeight="800" fontSize="30" fill="#0B1240">
                  2
                </text>
                {" "}
                <text x="146" y="186" textAnchor="middle" fontFamily="'Baloo Bhaijaan 2', sans-serif" fontWeight="800" fontSize="30" fill="#0B1240">
                  3
                </text>
                {" "}
                <text x="64" y="126" textAnchor="middle" fontFamily="'Baloo Bhaijaan 2', sans-serif" fontWeight="800" fontSize="30" fill="#0B1240">
                  4
                </text>
                {" "}
                <path d="M330 236 C 300 200, 260 190, 236 176 S 180 130, 154 118 S 100 66, 74 56" fill="none" stroke="#FFFFFF" strokeWidth="5" strokeLinecap="round" strokeDasharray="2 14" />
                {" "}
                <path d="M64 14 l9 20 22 3 -16 15 4 22 -19 -11 -19 11 4 -22 -16 -15 22 -3z" fill="#FFC93C" stroke="#FFFFFF" strokeWidth="4" strokeLinejoin="round" />
                {" "}
                <path d="M338 224 c-8 -10 -24 -6 -24 7 0 12 24 26 24 26 s24 -14 24 -26 c0 -13 -16 -17 -24 -7z" fill="#FFFFFF" />
              </svg>
            </div>
          </div>
        </div>
        <div className="kh-panel" id="kh-panel-2" role="tabpanel" aria-labelledby="kh-tab-2" data-panel="2" hidden>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(460px, 100%), 1fr))", gap: "40px", alignItems: "center", background: "#F3F5FF", borderRadius: "32px", padding: "clamp(24px, 4vw, 56px)" }}>
            <div style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
              <span style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "64px", lineHeight: "1", color: "#1E8F80" }}>
                03
              </span>
              <h3 style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontSize: "34px", lineHeight: "1.3" }}>
                الدرس يخرج من الكتاب… وينبض بالحياة أمام عيني طفلك!
              </h3>
              <p style={{ margin: "0", fontSize: "18px", lineHeight: "1.9", color: "#3A4270" }}>
                مع تقنية الواقع المعزّز، يتحوّل التعلّم إلى مغامرة حقيقيّة: كواكب تدور، وحيوانات تتحرّك، وشخصيّات تتكلّم، كلّها مرتبطة بمحاور الدروس. يقترب طفلك منها، ويكتشفها، ويتفاعل معها في عالم ثلاثيّ الأبعاد.
              </p>
              <strong style={{ alignSelf: "flex-start", padding: "10px 18px", borderRadius: "16px", background: "#F27DC2", color: "#3D0A28", fontSize: "19px" }}>
                لأنّ ما يعيشه الطفل بنفسه… لا يُنسى.
              </strong>
            </div>
            <img width="1600" height="738" loading="lazy" decoding="async" src="/assets/img/screen-encyclopedia.webp" alt="شاشة موسوعتي بالواقع المعزّز: عالم الحيوانات، رحلة حول الكواكب، اكتشف جسم الإنسان" style={{ width: "100%", display: "block", borderRadius: "24px", boxShadow: "0 20px 40px rgba(20,28,99,0.18)", transform: "rotate(-9deg)" }} />
          </div>
        </div>
        <div className="kh-panel" id="kh-panel-3" role="tabpanel" aria-labelledby="kh-tab-3" data-panel="3" hidden>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(460px, 100%), 1fr))", gap: "40px", alignItems: "center", background: "#F3F5FF", borderRadius: "32px", padding: "clamp(24px, 4vw, 56px)" }}>
            <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
              <span style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "64px", lineHeight: "1", color: "#1E8F80" }}>
                04
              </span>
              <h3 style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontSize: "30px", lineHeight: "1.35" }}>
                المحتويات التعليميّة بُنيت بشكل متدرّج يستند إلى هرم "بلوم" إذ:
              </h3>
              <ol style={{ margin: "0", padding: "0", listStyle: "none", display: "flex", flexDirection: "column", gap: "10px" }}>
                <li style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
                  <span style={{ width: "34px", height: "34px", borderRadius: "50%", background: "#46D3BE", color: "#0B1240", fontWeight: "800", display: "flex", alignItems: "center", justifyContent: "center", flex: "none" }}>
                    1
                  </span>
                  <span style={{ fontSize: "17px", lineHeight: "1.8" }}>
                    يستكشف المتعلّم المعرفة ويخزّنها بذاكرته ويستحضرها.
                  </span>
                </li>
                <li style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
                  <span style={{ width: "34px", height: "34px", borderRadius: "50%", background: "#6FA8FF", color: "#0B1240", fontWeight: "800", display: "flex", alignItems: "center", justifyContent: "center", flex: "none" }}>
                    2
                  </span>
                  <span style={{ fontSize: "17px", lineHeight: "1.8" }}>
                    يمارس أنشطة تضمن فهْم تلك المعرفة فهما مُكتملا.
                  </span>
                </li>
                <li style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
                  <span style={{ width: "34px", height: "34px", borderRadius: "50%", background: "#FFC93C", color: "#0B1240", fontWeight: "800", display: "flex", alignItems: "center", justifyContent: "center", flex: "none" }}>
                    3
                  </span>
                  <span style={{ fontSize: "17px", lineHeight: "1.8" }}>
                    يطبّق المكتسب ضمن وضعيات معيشة ويوظّفها توظيفا متدرّجا.
                  </span>
                </li>
                <li style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
                  <span style={{ width: "34px", height: "34px", borderRadius: "50%", background: "#FF9A3D", color: "#0B1240", fontWeight: "800", display: "flex", alignItems: "center", justifyContent: "center", flex: "none" }}>
                    4
                  </span>
                  <span style={{ fontSize: "17px", lineHeight: "1.8" }}>
                    يحلّل المعارف والمهارات المكتسبة ويعيد تركيبها لاستدماجها ضمن منظومته.
                  </span>
                </li>
                <li style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
                  <span style={{ width: "34px", height: "34px", borderRadius: "50%", background: "#F27DC2", color: "#0B1240", fontWeight: "800", display: "flex", alignItems: "center", justifyContent: "center", flex: "none" }}>
                    5
                  </span>
                  <span style={{ fontSize: "17px", lineHeight: "1.8" }}>
                    يقيّم المكتسب، يسند له قيمة ويطلق عليه حكما موضوعيّا.
                  </span>
                </li>
                <li style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
                  <span style={{ width: "34px", height: "34px", borderRadius: "50%", background: "#FFFFFF", border: "2px solid #A58BFF", color: "#0B1240", fontWeight: "800", display: "flex", alignItems: "center", justifyContent: "center", flex: "none" }}>
                    6
                  </span>
                  <span style={{ fontSize: "17px", lineHeight: "1.8" }}>
                    يبتكر ويبدع منتجا يستند إلى المكتسب محتوى وتمشّيات.
                  </span>
                </li>
              </ol>
            </div>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <svg viewBox="0 0 400 420" width="380" style={{ maxWidth: "100%", height: "auto" }} role="img" aria-label="أيقونة هرم بلوم بالعربيّة: التذكّر، الفهم، التطبيق، التحليل، التقييم، الإبداع">
                <defs>
                  <linearGradient id="khBloomBg" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0" stopColor="#8C6CFF" />
                    <stop offset="1" stopColor="#3B2F9F" />
                  </linearGradient>
                  {" "}
                  <pattern id="khBloomDots" width="22" height="22" patternUnits="userSpaceOnUse">
                    <circle cx="4" cy="4" r="2" fill="#FFFFFF" fillOpacity="0.18" />
                  </pattern>
                </defs>
                {" "}
                <rect x="0" y="18" width="400" height="400" rx="84" fill="#271E78" />
                {" "}
                <rect x="0" y="0" width="400" height="400" rx="84" fill="url(#khBloomBg)" />
                {" "}
                <rect x="0" y="0" width="400" height="400" rx="84" fill="url(#khBloomDots)" />
                {" "}
                <path d="M60 40 h280 a60 60 0 0 1 40 18 c-90 -10 -250 -10 -360 0 a60 60 0 0 1 40 -18z" fill="#FFFFFF" fillOpacity="0.2" />
                {" "}
                <g transform="translate(0,6)" fill="#000000" fillOpacity="0.22">
                  <polygon points="50,330 350,330 333.1,290 66.9,290" />
                  <polygon points="68.6,286 331.4,286 314.5,246 85.5,246" />
                  <polygon points="87.2,242 312.8,242 295.8,202 104.2,202" />
                  <polygon points="105.8,198 294.2,198 277.2,158 122.8,158" />
                  <polygon points="124.5,154 275.5,154 258.6,114 141.4,114" />
                  <polygon points="143.1,110 256.9,110 240,70 160,70" />
                </g>
                {" "}
                <polygon points="50,330 350,330 333.1,290 66.9,290" fill="#46D3BE" />
                {" "}
                <polygon points="68.6,286 331.4,286 314.5,246 85.5,246" fill="#6FA8FF" />
                {" "}
                <polygon points="87.2,242 312.8,242 295.8,202 104.2,202" fill="#FFC93C" />
                {" "}
                <polygon points="105.8,198 294.2,198 277.2,158 122.8,158" fill="#FF9A3D" />
                {" "}
                <polygon points="124.5,154 275.5,154 258.6,114 141.4,114" fill="#F27DC2" />
                {" "}
                <polygon points="143.1,110 256.9,110 240,70 160,70" fill="#FFFFFF" />
                {" "}
                <g fontFamily="'Baloo Bhaijaan 2', 'IBM Plex Sans Arabic', sans-serif" fontWeight="800" fontSize="21" fill="#0B1240" textAnchor="middle" direction="rtl">
                  <text x="200" y="317">
                    التذكّر
                  </text>
                  {" "}
                  <text x="200" y="273">
                    الفهم
                  </text>
                  {" "}
                  <text x="200" y="229">
                    التطبيق
                  </text>
                  {" "}
                  <text x="200" y="185">
                    التحليل
                  </text>
                  {" "}
                  <text x="200" y="141">
                    التقييم
                  </text>
                  {" "}
                  <text x="200" y="97" fill="#3B2F9F">
                    الإبداع
                  </text>
                </g>
                {" "}
                <path d="M200 22 l6 14 15 2 -11 10 3 15 -13 -8 -13 8 3 -15 -11 -10 15 -2z" fill="#FFC93C" stroke="#FFFFFF" strokeWidth="3" strokeLinejoin="round" />
                {" "}
                <text x="200" y="378" textAnchor="middle" fontFamily="'Baloo Bhaijaan 2', sans-serif" fontWeight="800" fontSize="26" fill="#FFFFFF" direction="rtl">
                  هرم بلوم
                </text>
              </svg>
            </div>
          </div>
        </div>
        <div className="kh-panel" id="kh-panel-4" role="tabpanel" aria-labelledby="kh-tab-4" data-panel="4" hidden>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(460px, 100%), 1fr))", gap: "40px", alignItems: "center", background: "#F3F5FF", borderRadius: "32px", padding: "clamp(24px, 4vw, 56px)" }}>
            <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
              <span style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "64px", lineHeight: "1", color: "#1E8F80" }}>
                05
              </span>
              <h3 style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontSize: "32px", lineHeight: "1.3" }}>
                ما يقدّمه تطبيق «خُطوة» للأولياء
              </h3>
              <p style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "700", fontSize: "22px", color: "#1E8F80" }}>
                أنت لا تحتاج أن تكون معلّمًا… «خُطوة» معك.
              </p>
              <ul style={{ margin: "0", padding: "0", listStyle: "none", display: "flex", flexDirection: "column", gap: "12px" }}>
                <li style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
                  <span style={{ width: "28px", height: "28px", borderRadius: "50%", background: "#46D3BE", display: "flex", alignItems: "center", justifyContent: "center", flex: "none", marginTop: "2px" }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0B1240" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <path d="M5 12l5 5 9-10" />
                    </svg>
                  </span>
                  <span style={{ fontSize: "17px", lineHeight: "1.8" }}>
                    <strong>
                      ترى تقدّمه بعينيك:
                    </strong>
                    {" ما أنجزه، وما يُتقنه، وأين يحتاج إليك."}
                  </span>
                </li>
                <li style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
                  <span style={{ width: "28px", height: "28px", borderRadius: "50%", background: "#46D3BE", display: "flex", alignItems: "center", justifyContent: "center", flex: "none", marginTop: "2px" }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0B1240" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <path d="M5 12l5 5 9-10" />
                    </svg>
                  </span>
                  <span style={{ fontSize: "17px", lineHeight: "1.8" }}>
                    <strong>
                      تثق في كلّ درس:
                    </strong>
                    {" محتوى مطابق للبرنامج الرسميّ، صمّمه مختصّون في التربية."}
                  </span>
                </li>
                <li style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
                  <span style={{ width: "28px", height: "28px", borderRadius: "50%", background: "#46D3BE", display: "flex", alignItems: "center", justifyContent: "center", flex: "none", marginTop: "2px" }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0B1240" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <path d="M5 12l5 5 9-10" />
                    </svg>
                  </span>
                  <span style={{ fontSize: "17px", lineHeight: "1.8" }}>
                    <strong>
                      تتابعه من فضائك الخاصّ:
                    </strong>
                    {" «فضاء الوليّ» يجمع كلّ ما يخصّ تعلّم طفلك في مكان واحد."}
                  </span>
                </li>
                <li style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
                  <span style={{ width: "28px", height: "28px", borderRadius: "50%", background: "#46D3BE", display: "flex", alignItems: "center", justifyContent: "center", flex: "none", marginTop: "2px" }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0B1240" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <path d="M5 12l5 5 9-10" />
                    </svg>
                  </span>
                  <span style={{ fontSize: "17px", lineHeight: "1.8" }}>
                    <strong>
                      تطمئنّ على وقته:
                    </strong>
                    {" مساحة آمنة صُمّمت للأطفال، كلّ دقيقة فيها مفيدة."}
                  </span>
                </li>
              </ul>
              <strong style={{ alignSelf: "flex-start", padding: "10px 18px", borderRadius: "16px", background: "#141C63", color: "#FFFFFF", fontSize: "19px" }}>
                أنت تُحبّه… ونحن نساعدك على إنجاحه.
              </strong>
            </div>
            <img width="1600" height="738" loading="lazy" decoding="async" src="/assets/img/screen-profile.webp" alt="شاشة ملفّي الشخصي وفضاء الوليّ في تطبيق خطوة" style={{ width: "100%", display: "block", borderRadius: "24px", boxShadow: "0 20px 40px rgba(20,28,99,0.18)", transform: "rotate(-10deg)" }} />
          </div>
        </div>
      </div>
    </section>
    <div style={{ display: "flex", flexDirection: "column", gap: "16px", maxWidth: "900px" }}>
      <span style={{ fontWeight: "700", color: "#1E8F80", fontSize: "16px" }}>
        مقاربتنا البيداغوجيّة
      </span>
      <h2 style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "clamp(34px, 4vw, 52px)", lineHeight: "1.2" }}>
        محتويات تعليميّة متنوّعة
      </h2>
      <p style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "700", fontSize: "clamp(24px, 2.6vw, 32px)", lineHeight: "1.4", color: "#1E8F80" }}>
        نُعِدّ طفلك للامتحان… ونُعِدّه للحياة.
      </p>
    </div>
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(340px, 100%), 1fr))", gap: "20px" }}>
      <article style={{ background: "#FFFFFF", border: "1px solid #E1E5F7", borderRadius: "28px", padding: "30px", display: "flex", flexDirection: "column", gap: "14px" }}>
        <span style={{ width: "64px", height: "64px", borderRadius: "20px", background: "#46D3BE", boxShadow: "0 6px 0 #1E8F80", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#0B1240" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M3 6.500C5 5 8 5 12 7c4-2 7-2 9-.5V19c-2-1.500-5-1.500-9 .5-4-2-7-2-9-.5z" />
            <path d="M12 7v12.500" />
          </svg>
        </span>
        <h3 style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontSize: "24px" }}>
          أنشطة وألعاب تعليميّة متنوّعة
        </h3>
        <p style={{ margin: "0", fontSize: "17px", lineHeight: "1.85", color: "#3A4270" }}>
          مرتبطة بالبرنامج الرسميّ، تساعده على اكتساب المعارف وتوظيفها في حياته اليوميّة.
        </p>
      </article>
      <article style={{ background: "#FFFFFF", border: "1px solid #E1E5F7", borderRadius: "28px", padding: "30px", display: "flex", flexDirection: "column", gap: "14px" }}>
        <span style={{ width: "64px", height: "64px", borderRadius: "20px", background: "#FFC93C", boxShadow: "0 6px 0 #C48E00", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#0B1240" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M12 20s-7-4.400-7-10a4 4 0 0 1 7-2.600A4 4 0 0 1 19 10c0 5.600-7 10-7 10z" />
          </svg>
        </span>
        <h3 style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontSize: "24px" }}>
          قيم يكبر عليها
        </h3>
        <p style={{ margin: "0", fontSize: "17px", lineHeight: "1.85", color: "#3A4270" }}>
          المواطنة، واحترام الآخر، وحقوق الإنسان وحقوق الطفل.
        </p>
      </article>
      <article style={{ background: "#FFFFFF", border: "1px solid #E1E5F7", borderRadius: "28px", padding: "30px", display: "flex", flexDirection: "column", gap: "14px" }}>
        <span style={{ width: "64px", height: "64px", borderRadius: "20px", background: "#A58BFF", boxShadow: "0 6px 0 #6A4FD0", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#0B1240" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <circle cx="12" cy="12" r="9" />
            <path d="M3 12h18M12 3c3 3.500 3 14.500 0 18M12 3c-3 3.500-3 14.500 0 18" />
          </svg>
        </span>
        <h3 style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontSize: "24px" }}>
          عين على العالم
        </h3>
        <p style={{ margin: "0", fontSize: "17px", lineHeight: "1.85", color: "#3A4270" }}>
          يكتشف قضايا عصره، من حماية البيئة إلى أهداف التنمية المستدامة، ويستعدّ لمستقبله بثقة.
        </p>
      </article>
    </div>
    <blockquote style={{ margin: "0", background: "#141C63", color: "#FFFFFF", borderRadius: "28px", padding: "clamp(24px, 4vw, 40px)", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "clamp(24px, 2.8vw, 36px)", lineHeight: "1.4", textAlign: "center" }}>
      <span style={{ color: "#FFC93C" }}>
        «خُطوة»
      </span>
      {" نافذة طفلك على عالم يتغيّر… ليكون جزءًا من تغييره."}
    </blockquote>
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(460px, 100%), 1fr))", gap: "20px" }}>
      <article style={{ background: "#FFC93C", color: "#0B1240", borderRadius: "32px", padding: "36px", display: "flex", flexDirection: "column", gap: "16px", justifyContent: "center" }}>
        <h3 style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "32px", lineHeight: "1.3" }}>
          انضمّوا إلينا اليوم في رحلة تعليميّة شيّقة وممتعة مع تطبيق "خُطوة".
        </h3>
        <p style={{ margin: "0", fontSize: "17px", lineHeight: "1.9" }}>
          ساعدوا أطفالكم على اكتشاف مهاراتهم وتحقيق أحلامهم من خلال تعليم مبتكر وشخصيّ.
        </p>
        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
          <a href="https://play.google.com/store/apps/details?id=com.DMNovaComany.Khotoua&pcampaignid=web_share" target="_blank" rel="noopener" style={{ display: "inline-flex", alignItems: "center", minHeight: "54px", padding: "0 22px", borderRadius: "18px", background: "#0B1240", color: "#FFFFFF", fontWeight: "800", textDecoration: "none" }}>
            حمّل التطبيق الآن
          </a>
          <a href="https://khotoua.com/KHOTOUA_DEMO/Khotoua%20Inscription%20Portrait.dc.html" target="_blank" rel="noopener" style={{ display: "inline-flex", alignItems: "center", minHeight: "54px", padding: "0 22px", borderRadius: "18px", border: "2px solid #0B1240", color: "#0B1240", fontWeight: "800", textDecoration: "none" }}>
            جرّب العرض التجريبي
          </a>
        </div>
      </article>
    </div>
  </section>
);

export default Pedagogy;
